import { render, staticRenderFns } from "./OfferAndOnBoardDocuments.vue?vue&type=template&id=0610c3fc"
import script from "./OfferAndOnBoardDocuments.vue?vue&type=script&lang=js"
export * from "./OfferAndOnBoardDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports